export default __webpack_public_path__ + "static/media/ic_info.afa0ac43.svg";